import { render, staticRenderFns } from "./MobileBottomNav.vue?vue&type=template&id=696af1f8&scoped=true"
import script from "./MobileBottomNav.vue?vue&type=script&lang=js"
export * from "./MobileBottomNav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "696af1f8",
  null
  
)

export default component.exports